module.exports = __webpack_public_path__ + "img/i-Seller.450bc792.jpg";